import { render } from "./Container Sizes.vue?vue&type=template&id=1bd3beb1"
import script from "./Container Sizes.vue?vue&type=script&lang=js"
export * from "./Container Sizes.vue?vue&type=script&lang=js"

import "./Container Sizes.vue?vue&type=style&index=0&id=1bd3beb1&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__